import * as React from "react";

const CaretRight: React.FC = () => {
    return <svg width="5px" height="10px" viewBox="0 0 5 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-691.000000, -362.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(612.000000, 132.000000)">
                    <polygon points="0 0 5 5 0 10"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(CaretRight);
